import { datadogRum } from "@datadog/browser-rum";

export const datadogAddAction = (name: string, context?: object): void => {
  try {
    datadogRum.addAction(name, context);
  } catch (error) {
    console.warn("Datadog addAction failed:", error);
  }
};

export const datadogAddError = (error: Error, context?: object): void => {
  try {
    datadogRum.addError(error, context);
  } catch (e) {
    console.warn("Datadog addError failed:", e);
  }
};
